<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VNmZHn/tc-custom/9781504031363.jpg?1734200950694" alt="This image is the cover for the book Dead as a Dinosaur, The Mr. and Mrs. North Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead as a Dinosaur, The Mr. and Mrs. North Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>When a paleontologist is murdered, Mr. and Mrs. North go digging for his killer</b><br/><br/> The office of Dr. Orpheus Preson is filled with remains, the bones of long dead dinosaurs. He waves one of them at the NYPD detective, demanding the police stop the person who’s been sending workmen to his house—an endless parade of bricklayers, butlers, French tutors, and tree surgeons, none of whom Preson hired, and all of whom expect payment. There’s nothing law enforcement can do, which means it’s time to call the only two people in New York who can help: Pamela and Jerry North.<br/>  <br/> A fashionable literary couple who’s made a habit of solving mysteries between martinis, the Norths have known Dr. Preson since Jerry published his first book. The amateur detectives vow to do what they can for the perturbed paleontologist, but it’s too little too late. When Dr. Preson is found murdered, the Norths will find that the poor man had more than one kind of skeleton in his closet.<br/>  <br/><i>Dead as a Dinosaur </i>is the 16th book in the Mr. and Mrs. North Mysteries, but you may enjoy reading the series in any order.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Lockridge, Richard Lockridge
      </h2>
      
      <p class="authorDescription body article">Frances and Richard Lockridge were some of the most popular names in mystery during the forties and fifties. Having written numerous novels and stories, the husband-and-wife team was most famous for their Mr. and Mrs. North Mysteries. What started in 1936 as a series of stories written for the <I>New Yorker</I> turned into twenty-six novels, including adaptions for Broadway, film, television, and radio. The Lockridges continued writing together until Frances&rsquo;s death in 1963, after which Richard discontinued the Mr. and Mrs. North series and wrote other works until his own death in 1982.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d1ff901